import React, { FC } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import MenuUser from "../MenuUser";
import makeStyles from '@mui/styles/makeStyles';
import theme from "src/theme/light";

export interface UserInfo {
  name: string;
  email?: string;
  image?: string;
  icon?: string | null;
};
export interface UserParams {
  user: UserInfo;
};

const useStyles = makeStyles((_theme) => ({
  listItem: {
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
    },
  },
}));


const MenuUserInfo: FC<UserParams> = ({ user }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const userInfo:UserInfo = { ...user };
  userInfo.email = userInfo.email ? userInfo.email : "";
  userInfo.image = userInfo.image ? userInfo.image : "";
  userInfo.icon = userInfo.icon ? userInfo.icon : "person";
  userInfo.name = userInfo.name ? user?.name.toLowerCase() : "";
  const avatarName = userInfo.name.match(/(\b\S)?/g)?.join("")?.match(/(^\S|\S$)?/g)?.join("").toUpperCase();
  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <ListItem className={classes.listItem}>
      <ListItemAvatar>
        <IconButton onClick={handleClick} size="small">
          <Avatar>{avatarName}</Avatar>
        </IconButton>
      </ListItemAvatar>

      <MenuUser data={userInfo} element={anchorEl} onChange={setAnchorEl} />
    </ListItem>
  );
};

export { MenuUserInfo };
